// ── SVG icon constants ────────────────────────────────────────────────────────
// All small inline icons used throughout the UI.

import { P } from './tokens';

export const UPLOAD_SVG = `<svg width="56" height="56" viewBox="0 0 24 24" fill="none">
  <path d="M12 16V5" stroke="${P}" stroke-width="1.7" stroke-linecap="round"/>
  <path d="M8 8.5L12 4.5L16 8.5" stroke="${P}" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
  <rect x="3.5" y="17" width="17" height="3.5" rx="1.5" fill="${P}" fill-opacity="0.15"/>
  <path d="M3.5 18.75h17" stroke="${P}" stroke-width="1.7" stroke-linecap="round"/>
</svg>`;

export const GOOGLE_SVG = `<svg width="26" height="26" viewBox="0 0 18 18">
  <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908C18.622 14.232 17.64 11.925 17.64 9.2z"/>
  <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z"/>
  <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"/>
  <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z"/>
</svg>`;

export const APPLE_SVG = `<svg width="21" height="26" viewBox="0 0 814 1000">
  <path fill="currentColor" d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76.5 0-103.7 40.8-165.9 40.8s-105.4-57.9-155.8-127.5c-58.5-81.3-104.6-209.4-104.6-330.2 0-194.3 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z"/>
</svg>`;

export const EXPAND_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
  <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>
</svg>`;

export const DOWNLOAD_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"/>
</svg>`;

export const AVATAR_EMPTY_SVG = `<svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="8" r="3.5"/>
  <path d="M5.5 19c.9-2.8 3.4-4.5 6.5-4.5s5.6 1.7 6.5 4.5"/>
</svg>`;
